import { AddIcon } from 'element';
import { Box, BoxProps, Button } from 'extended-oxygen-elements';
import React from 'react';
import { usePayConditionsListContext } from '../pay-conditions-list-context';

export default function AddWeekendLoadingButton(props: BoxProps) {
  const { isOpen, openCreate } = usePayConditionsListContext();

  if (isOpen) {
    return null;
  }

  return (
    <Box {...props}>
      <Button
        variant="text"
        startIcon={<AddIcon />}
        onClick={openCreate}
        data-testid={'add-pay-condition-btn'}
      >
        Add Weekend Pay condition
      </Button>
    </Box>
  );
}
